import React from "react"
import {Select, SelectProps} from "antd"

interface PropsTypes extends SelectProps {
    isInvalid?: any
    containerStyle?: any
}

export const FormSelect: React.FC<PropsTypes> = ({isInvalid, containerStyle, ...props}) => {
    const multiple = props?.mode === 'multiple' || props?.mode === 'tags'

    return (
        <div className="form-select-container" style={containerStyle}>
            <div style={{position: 'relative'}}>
                <Select className="form-select"
                        status={isInvalid ? 'error' : ''}
                        defaultActiveFirstOption
                        {...props}
                />
                {
                    props.value && !multiple
                        ? <span style={{position: 'absolute', top: 1, left: 12, fontSize: 11, zIndex: 100, fontWeight: 600, color: '#8c8c8c', opacity: 0.5}}>
                    {props.placeholder}</span>
                        : null
                }
            </div>
            {isInvalid ? <div className="input-error-visible">{isInvalid}</div> : null}
        </div>
    )
}